import { Checkbox } from "antd";
import React from 'react';

interface IProps {
    is_cleaning: boolean

    onChange(value: boolean): void
}

const Cleaning: React.FC<IProps> = ({ is_cleaning, onChange }) => {

    return <div>
        <Checkbox
            className='text-[15px]'
            checked={is_cleaning}
            onChange={({ target }) => onChange(target.checked)}
        >
            Cleaning
        </Checkbox>
    </div>;
};

export default Cleaning;
